<div *ngIf="isImpersonating$ | async" class="impersonation-banner">
  <div class="banner-content">
    <div class="banner-info">
      <div class="warning-icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2L1 21h22L12 2zm0 3.17L19.83 19H4.17L12 5.17zM11 16h2v2h-2zm0-6h2v4h-2z" />
        </svg>
      </div>
      <div class="banner-text">
        <strong>IMPERSONATING:</strong> You are viewing this application as
        <strong>{{ (impersonatedUserInfo$ | async)?.username }}</strong
        >. Your actions are being logged as
        <strong>{{ (impersonatorInfo$ | async)?.username }}</strong
        >.
      </div>
    </div>
    <button class="banner-button" (click)="stopImpersonating()">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path
          d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
        />
      </svg>
      Stop Impersonating
    </button>
  </div>
</div>
